import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaLinkedin, FaGithub, FaFacebook } from "react-icons/fa";

const Icons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  top: 2rem;
  right: 0rem;
  z-index: 3;
  color: ${(props) => props.theme.text};

  & > *:not(:last-child) {
    margin: 0 0.6rem;
  }

  @media (max-width: 466px) {
    top: 1.3rem;
  }
`;

const Line = styled(motion.span)`
  width: 8rem;
  height: 2px;
  background-color: ${(props) => props.theme.text};

  @media (max-width: 466px) {
    width: 5rem;
  }
`;

const SocialIcons = (props) => {
  return (
    <Icons>
      <motion.div
        initial={{ transform: "scale(0)" }}
        animate={{ scale: [0, 1, 1.5, 1] }}
        transition={{ type: "spring", duration: 1, delay: 1.9 }}
      >
        <NavLink
          style={{ color: "inherit" }}
          target="_blank"
          to={{
            pathname:
              "https://www.linkedin.com/in/shane-del-moira-mantua-058788234"
          }}
        >
          <FaLinkedin size={"4vh"} />
        </NavLink>
      </motion.div>

      <motion.div
        initial={{ transform: "scale(0)" }}
        animate={{ scale: [0, 1, 1.5, 1] }}
        transition={{ type: "spring", duration: 1, delay: 2 }}
      >
        <NavLink
          style={{ color: "inherit" }}
          target="_blank"
          to={{ pathname: "https://github.com/devShaneMantua" }}
        >
          <FaGithub size={"4vh"} />
        </NavLink>
      </motion.div>

      <motion.div
        initial={{ transform: "scale(0)" }}
        animate={{ scale: [0, 1, 1.5, 1] }}
        transition={{ type: "spring", duration: 1, delay: 2.1 }}
      >
        <NavLink
          style={{ color: "inherit" }}
          target="_blank"
          to={{ pathname: "https://www.facebook.com/shanedelmoira.mantua.7" }}
        >
          <FaFacebook size={"4vh"} />
        </NavLink>
      </motion.div>

      <Line
        initial={{ x: 150 }}
        animate={{ x: 0 }}
        transition={{ type: "spring", duration: 2, delay: 1.4 }}
      />
    </Icons>
  );
};

export default SocialIcons;
